export default __webpack_public_path__ + "static/1300-5bc09c43fed0a16504e7269992dcd070.gif";